import type { ExpenseEntry } from './types';

/*
 * Las notas que paga una factura las marca SIEMPRE el usuario (Alex, 14 oct
 * 2026). Hasta entonces aqui vivia `seleccionSugerida`, que marcaba sola «lo
 * mas antiguo que cabe»: con eso se juntaban notas que no eran de esa factura
 * sin que nadie se enterara. El unico atajo que queda es «suman justo»
 * (`combinacionUnica` en ./gastos): solo si UNA combinacion suma exacto (± 1).
 */

/**
 * Fecha en la que salio el dinero de una factura que se da por pagada al
 * conciliar: el ultimo pago de sus notas, o el dia de la conciliacion si
 * ninguna lleva fecha. La usan la API y la demo, que antes la repetian.
 */
export function ultimaFechaDePago(
  notas: Array<Pick<ExpenseEntry, 'paymentDate'>>,
  siNinguna: string,
): string {
  return (
    notas
      .map((n) => n.paymentDate)
      .filter((d): d is string => Boolean(d))
      .sort()
      .at(-1) ?? siNinguna
  );
}
